import { render, staticRenderFns } from "./LoginPageV2.vue?vue&type=template&id=7151899c&scoped=true&lang=pug"
import script from "./LoginPageV2.vue?vue&type=script&lang=js"
export * from "./LoginPageV2.vue?vue&type=script&lang=js"
import style0 from "./LoginPageV2.vue?vue&type=style&index=0&id=7151899c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7151899c",
  null
  
)

export default component.exports